module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.config.title) ? _c('site-header', {
    attrs: {
      "config": _vm.config
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "main"
  }, [_c('sidebar', {
    attrs: {
      "chapters": _vm.chapters
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.chapter.title) ? _c('div', {
    staticClass: "content-header"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("\n          " + _vm._s(_vm.chapter.title) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isComponent) ? _c(_vm.chapter.content, {
    tag: "component"
  }) : _c('div', {
    staticClass: "markdown-body",
    domProps: {
      "innerHTML": _vm._s(_vm.chapter.content)
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c3af8dd0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3af8dd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 29
// module chunks = 0